import * as React from "react"
import { AlertTriangle, X } from 'lucide-react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./table"

const DataTable = ({
  columns,
  data,
  className,
  emptyMessage = "No data available",
  onRowClick,
  selectedRows = {},
  rowErrors = {},
  onClearRowError,
  ...props
}) => {
  return (
    <div className={`overflow-x-auto ${className} rounded-lg`} {...props}>
      <div className="min-w-0">
        <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column) => (
              <TableHead 
                key={column.accessorKey || column.id} 
                className={column.headerClassName}
                style={column.headerStyle}
              >
                {typeof column.header === 'function' ? column.header() : column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((row, index) => {
              const rowId = row.id || String(row.scan_id || index);
              const isSelected = !!selectedRows[rowId];
              const hasError = !!rowErrors[rowId];
              
              return (
                <React.Fragment key={rowId}>
                  <TableRow
                    className={`${onRowClick ? "cursor-pointer" : ""} ${
                      isSelected 
                        ? "border-purple-200" 
                        : "hover:bg-gray-50"
                    }`}
                    style={isSelected ? { backgroundColor: '#faf5ff' } : {}}
                    onClick={() => onRowClick?.(row)}
                  >
                  {columns.map((column) => (
                    <TableCell 
                      key={column.accessorKey || column.id}
                      className={column.cellClassName}
                      style={column.cellStyle}
                    >
                      {column.cell 
                        ? column.cell(row[column.accessorKey], row, index)
                        : row[column.accessorKey]
                      }
                    </TableCell>
                  ))}
                </TableRow>
                
                {hasError && (
                  <TableRow className="bg-red-50 border-red-200">
                    <TableCell colSpan={columns.length} className="p-0">
                      <div className="flex items-center gap-3 p-3 text-red-700">
                        <AlertTriangle className="w-4 h-4 text-red-600 flex-shrink-0" />
                        <span className="text-sm flex-1">{rowErrors[rowId]}</span>
                        <button
                          onClick={() => onClearRowError?.(rowId)}
                          className="text-red-500 hover:text-red-700 transition-colors"
                          aria-label="Dismiss error"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                )}
                </React.Fragment>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center py-8">
                {emptyMessage}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      </div>
    </div>
  )
}

export { DataTable }